module.exports = __webpack_public_path__ + "img/2023-26.22484b1e.jpg";